import { render } from "./DButtonDropdown.vue?vue&type=template&id=eabaf274&scoped=true"
import script from "./DButtonDropdown.vue?vue&type=script&lang=js"
export * from "./DButtonDropdown.vue?vue&type=script&lang=js"

import "./DButtonDropdown.vue?vue&type=style&index=0&id=eabaf274&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabaf274"]])

export default __exports__